import  gql  from 'graphql-tag'

export const regionalsReports = gql`query Regionals($isActive: Boolean, $reportStartDate: Date, $reportEndDate: Date){ 
    regionalsReports: regionals(isActive:$isActive){
        edges{
            node{
                id
                name
                inProcess(reportStartDate:$reportStartDate, reportEndDate: $reportEndDate)
                finished(reportStartDate:$reportStartDate, reportEndDate: $reportEndDate)
                averageTime(reportStartDate:$reportStartDate, reportEndDate: $reportEndDate)
                productionActivityCount(reportStartDate:$reportStartDate, reportEndDate: $reportEndDate)
                commerceActivityCount(reportStartDate:$reportStartDate, reportEndDate: $reportEndDate)
                servicesActivityCount(reportStartDate:$reportStartDate, reportEndDate: $reportEndDate)
            }
        }
    }
}`;
